<template>
	<div class="tab-pane active" id="step7">
		<h2 class="hidden-lg">{{ $t("tab.submit") }}</h2>
		<div class="row">
			<div class="col-md-12">
				<div v-if="requestSubmitted">
					<div class="register-area">
						<div class="col-md-12">
							<div class="box-for overflow">
								<div class="col-md-12 col-xs-12 register-blocks">
									<h2>{{ $t('success.title') }}</h2>
									<p>{{ msgSuccess }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="register-area" v-if="requestInProgress">
						<div class="col-md-12">
							<div class="box-for overflow">
								<div class="col-md-12 col-xs-12 register-blocks">
									<p>{{ $t('labels.request_in_progress') }}</p>
									<div class="progress">
										<div
											class="progress-bar progress-bar-striped active"
											role="progressbar"
											aria-valuenow="100"
											aria-valuemin="0"
											aria-valuemax="100"
											style="width: 100%">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="register-area" v-else>
						<div class="col-md-8">
							<div class="box-for overflow">
								<div>
									<span v-if="requestAsType > 1"
										class="btn"
										@click="resetRequestAsType()">
										<i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}
									</span>
								</div>

								<div class="col-md-12 col-xs-12 register-blocks" v-if="requestAsType > 0">
									<h2>{{ $t('labels.contact_data') }}:</h2>
									<h5><strong>{{ $t('labels.client') }}</strong></h5>

									<div class="form-group" v-if="isEmbedded != null">
										<label for="company">{{ $t('forms.company') }}*:</label>
										<input
											type="text"
											class="form-control input-sm"
											v-model.trim="company"
											key="input-company">
									</div>

									<div class="form-group" v-if="user">
										<label class="control-label" for="name">{{ $t('forms.name') }}*:</label>
										<input :value="user.name" disabled class="form-control input-sm" type="text">
									</div>
									<div class="form-group" v-if="user">
										<label class="control-label" for="email">{{ $t('forms.email') }}*:</label>
										<input :value="user.email" disabled class="form-control input-sm" type="email">
									</div>
									<div class="form-group" :class="{'has-error': (registrationErrors.has('name') || submitErrors.has('name')) }" v-if="requestAsType > 1">
										<label class="control-label" for="name">{{ $t('forms.name') }}*:</label>
										<input
											id="name"
											key="input-name"
											class="form-control input-sm"
											type="text"
											name="name"
											:placeholder='$t("forms.placeholders.name")'
											v-model.trim="name">
										<p class="text-danger" v-if="registrationErrors.has('name') || submitErrors.has('name')">
											<span v-if="registrationErrors.has('name')" >{{ registrationErrors.get('name') }}</span>
											<span v-if="submitErrors.has('name')" >{{ submitErrors.get('name') }}</span>
										</p>
									</div>
									<div class="form-group" :class="{'has-error': registrationErrors.has('email') || submitErrors.has('email') }" v-if="requestAsType > 1">
										<label class="control-label" for="email">{{ $t('forms.email') }}*:</label>
										<input
											id="email"
											name="email"
											key="input-email-reg"
											class="form-control input-sm"
											type="email"
											:placeholder='$t("forms.placeholders.email")'
											v-model.trim="email">
										<p class="text-danger" v-if="registrationErrors.has('email') || submitErrors.has('email')">
											<span v-if="registrationErrors.has('email')" >{{ registrationErrors.get('email') }}</span>
											<span v-if="submitErrors.has('email')" >{{ submitErrors.get('email') }}</span>
										</p>
									</div>
									<div class="form-group" v-if="requestAsType > 2" :class="{'has-error': registrationErrors.has('password') || submitErrors.has('password') }">
										<label for="password">{{ $t('forms.password') }}*:</label>
										<input
											type="password"
											class="form-control input-sm"
											id="password"
											v-model.trim="password"
											:placeholder='$t("forms.placeholders.password")'>
										<p class="text-danger" v-if="errors.has('password')">{{ errors.first('password') }}</p>
									</div>
									<div class="form-group" v-if="requestAsType > 2">
										<label for="passwordConfirmation">{{ $t('forms.passwordConfirmation') }}*:</label>
										<input
											type="password"
											class="form-control input-sm"
											id="passwordConfirmation"
											v-model.trim="passwordConfirmation"
											:placeholder='$t("forms.placeholders.passwordConfirmation")'
											key="input-password-confirmation">
									</div>

									<div class="form-group" :class="{'has-error': registrationErrors.has('country') || submitErrors.has('country')}">
										<label for="country_id" class="control-label">{{ $t('forms.country') }}*</label>
										<select
											id="country_id"
											v-model="country_id"
											class="form-control"
											@change="countryChanged(country_id)">
											<option v-for="country in countryOptions" v-bind:value="country.id" :key="country.id">
												{{ !inEnglish ? country.name : country.name_english }}
											</option>
										</select>
									</div>

									<div class="form-group" v-show="requestAsType >= 1" :class="{'has-error': registrationErrors.has('company') || submitErrors.has('company')}">
										<label for="company">{{ (availableLegalForms.length > 0) ? $t('forms.company') : $t('forms.company_and_legal_form') }}*:</label>
										<input
											type="text"
											class="form-control input-sm"
											id="company"
											key="input-company"
											name="company"
											:placeholder='$t("forms.placeholders.company")'
											v-model.trim="company">
									</div>

									<div v-if="availableLegalForms.length > 0" class="form-group" :class="{'has-error': registrationErrors.has('country_legal_form_id') || submitErrors.has('country_legal_form_id')}">
										<label for="country_legal_form_id" class="control-label">{{ $t('forms.legal_form') }}*</label>
										<select
											id="country_legal_form_id"
											v-model="country_legal_form_id"
											class="form-control">
										<option v-for="legalForm in availableLegalForms"
											:value="legalForm.id"
											:key="legalForm.id">
												{{ legalForm.name_local }}
											</option>
										</select>
									</div>

									<div class="form-group">
										<div class="row">
											<label for="street_name" class="col-md-12 control-label">{{ $t('forms.street_name') }}*</label>
											<div class="col-md-9" :class="{'has-error': registrationErrors.has('street_name') || submitErrors.has('street_name')}">
												<input
													id="street_name"
													key="input-street-name"
													type="street_name"
													class="form-control input-sm"
													name="street_name"
													:placeholder="$t('forms.placeholders.street_name')"
													v-model.trim="streetName">
											</div>
											<div class="col-md-3" :class="{'has-error': registrationErrors.has('street_number') || submitErrors.has('street_number')}">
												<input
													id="street_number"
													key="input-street-number"
													type="street_number"
													class="form-control input-sm"
													name="street_number"
													:placeholder="$t('forms.placeholders.street_number')"
													v-model.trim="streetNumber">
											</div>
										</div>
									</div>
									<div class="form-group">
										<div class="row">
											<label for="place" class="col-md-12 control-label">{{ $t('forms.zip_place') }}*</label>
											<div class="col-md-3" :class="{'has-error': registrationErrors.has('zip') || submitErrors.has('zip')}">
												<input
													id="zip"
													name="zip"
													key="input-zip"
													type="zip"
													class="form-control input-sm"
													:placeholder="$t('forms.placeholders.zip')"
													v-model.trim="zip">
											</div>
											<div class="col-md-9" :class="{'has-error': registrationErrors.has('place') || submitErrors.has('place')}">
												<input
													id="place"
													name="place"
													key="input-place"
													type="text"
													class="form-control input-sm"
													:placeholder="$t('forms.placeholders.place')"
													v-model.trim="place">
											</div>
										</div>
									</div>

									<div class="form-group row" v-show="requestAsType >= 1" :class="{'has-error': registrationErrors.has('vat_id') || submitErrors.has('vat_id')}">
										<label for="vat_id_prefix" class="col-md-12 control-label">{{ $t('forms.vat_id') }} <span v-show="vatRequired">*</span>:</label>
										<div class="col-md-2">
											<select
												id="vat_id_prefix"
												v-model="vat_id_prefix"
												class="form-control">
												<option v-for="country in countryCodeOptions" v-bind:value="country.country_code" :key="country.id">
													{{ country.country_code }}
												</option>
											</select>
										</div>
										<div class="col-md-10">
											<input
												type="text"
												class="form-control"
												id="vat_id"
												key="input-vat-required"
												name="vat_id"
												:placeholder='$t("forms.placeholders.vat_id")'
												v-model.trim="vat_id"
												@keyup="checkVatId">
										</div>
									</div>
									<p class="text-danger" v-if="vatRequired && vat_id && !hasCorrectVatId && !vatCheckInProgress">
										{{ $t('errors.vat_id') }}
									</p>
									<p class="text-info" v-if="vatRequired && vat_id && vatCheckInProgress">
										<div><div class="loader"></div> {{ $t('forms.placeholders.check') }} </div>
									</p>
									<p class="text-success" v-if="vatRequired && vat_id && hasCorrectVatId && !vatCheckInProgress">
									<div>{{ $t('checklist.vat_set') }} </div>
									</p>
									<div v-if="requestAsType >= 1" class="form-group"
										:class="{'has-error': registrationErrors.has('use_order_number') || submitErrors.has('use_order_number')}">
										<label for="use_order_number">{{ $t('forms.use_order_number') }} <span>*</span> :</label>
										<div class="radio">
											<label>
												<input
													type="radio"
													name="use_order_number"
													id="use_order_number2"
													key="input-use-order-number-two"
													:value="true"
													v-model="use_order_number"
													style="width: 13px">
												{{ $t('labels.yes') }}
											</label>
										</div>
										<div class="radio">
											<label>
												<input
													type="radio"
													name="use_order_number"
													id="use_order_number1"
													:value="false"
													v-model="use_order_number"
													style="width: 13px">
												{{ $t('labels.no') }}
											</label>
										</div>
									</div>
									<p v-if="registrationErrors.has('use_order_number') || submitErrors.has('use_order_number')"
										class="text-danger"
										v-html="$t('errors.use_order_number')">
									</p>

									<div v-if="use_order_number && requestAsType >= 1"
										class="form-group"
										:class="{'has-error': registrationErrors.has('order_number') || submitErrors.has('order_number')}">
										<label for="order_number">{{ $t('forms.order_number') }} <span>*</span> :</label>
										<input
											type="text"
											class="form-control input-sm"
											id="order_number"
											key="input-order-number"
											name="order_number"
											:placeholder='$t("forms.placeholders.order_number")'
											v-model.trim="order_number">
									</div>
									<p class="text-danger" v-if="use_order_number && registrationErrors.has('order_number') || submitErrors.has('order_number')">
										{{ $t('errors.order_number') }}
									</p>
									<div v-if="use_order_number === false && requestAsType >= 1"
										class="form-group"
										:class="{'has-error': registrationErrors.has('order_number') || submitErrors.has('order_number')}">
										<p><b>{{ $t('forms.order_number_notice') }}</b></p>
									</div>

									<div class="form-group" :class="{'has-error': registrationErrors.has('phone') || submitErrors.has('phone')}">
										<label for="phone" class="control-label">{{ $t('forms.phone') }}</label>
										<input
											id="phone"
											name="phone"
											key="input-phone"
											type="text"
											class="form-control input-sm"
											v-model.trim="phone"
											:placeholder="$t('forms.placeholders.phone')">
									</div>

                  <!-- Exhibition hall select is only shown if unset or has errors -->
									<div
                    v-show="!exhibitionHall || exhibitionHall.trim() === '' || registrationErrors.has('exhibitionHall') || submitErrors.has('exhibitionHall')"
                    class="form-group"
                  >
										<label for="exhibitionHall">
											{{ $t('forms.hall') }}{{ (exhibition.hall_settings.hall_name_required) ? '*' : ''}}:
										</label>
										<select v-if="exhibition.hall_settings.hall_name_selection_active" v-model="exhibitionHall"
											class="form-control">
											<option v-for="option,index in hallOptions" :key="index" :value="option.value">
												{{ option.label }}
											</option>
										</select>
										<input v-else
											type="text"
											class="form-control input-sm"
											id="exhibitionHall"
											v-model.trim="exhibitionHall"
											:placeholder='$t("forms.placeholders.hall")'
											:disabled="isEmbedded !== null">
										<p v-if="registrationErrors.has('exhibitionHall') || submitErrors.has('exhibitionHall')"
											class="text-danger"
											v-html="$t('errors.exhibition_hall_regex')">
										</p>
									</div>

                  <!-- Exhibition booth number select is only shown if unset or has errors -->
									<div 
                    v-show="!exhibitionBoothNumber || exhibitionBoothNumber.trim() === '' || registrationErrors.has('exhibitionBoothNumber') || submitErrors.has('exhibitionBoothNumber')"
                    class="form-group"
                  >
										<label for="exhibitionBoothNumber">
											{{ $t('forms.booth_number') }}{{ (exhibition.hall_settings.booth_name_required) ? '*' : ''}}:
										</label>
										<input
											type="text"
											class="form-control input-sm"
											id="exhibitionBoothNumber"
											v-model.trim="exhibitionBoothNumber"
											:placeholder='$t("forms.placeholders.booth_number")'
											:disabled="isEmbedded !== null">
										<p v-if="registrationErrors.has('exhibitionBoothNumber') || submitErrors.has('exhibitionBoothNumber')"
											class="text-danger"
											v-html="$t('errors.exhibition_booth_number_regex')">
										</p>
									</div>
									<div class="form-group">
										<label for="comment">{{ $t('forms.comment') }}:</label>
										<textarea
											name="comment"
											id="comment"
											class="form-control input-sm"
											style="resize: vertical"
											v-model="comment"
											rows="5"
											:placeholder='$t("forms.placeholders.comment")'>
										</textarea>
									</div>

									<!-- optional bill Address -->
									<h5 style="margin-top: 24px"><strong>{{ $t('labels.different_billing_address') }}</strong></h5>
									<div class="form-group">
										<p><b>{{ $t('forms.bill_address_notice') }}</b></p>
									</div>
									<div class="form-group">
										<div class="text-center">
											<button type="button" class="btn btn-warning" @click="toggleHasBillAddress">
												{{ hasBillAddress ? $t("labels.remove_bill_address") : $t("labels.add_bill_address") }}
											</button>
										</div>
									</div>

									<div v-if="hasBillAddress" :key="hasBillAddress">
										<div class="form-group bill" :class="{'has-error': submitErrors.has('bill_country_id')}">
											<label for="bill_country_id" class="control-label">{{ $t('forms.country') }}</label>
											<select
												id="bill_country_id"
												v-model="bill_country_id"
												class="form-control"
												@change="billCountryChanged(bill_country_id)">
												<option v-for="country in countryOptions"
													:value="country.id"
													:key="country.id">
													{{ !inEnglish ? country.name : country.name_english }}
												</option>
											</select>
										</div>

										<div class="form-group bill">
											<div class="row">
												<label for="bill_company" class="col-md-12 control-label">{{ (availableBillLegalForms.length > 0) ? $t('forms.company') : $t('forms.company_and_legal_form') }}*:</label>
												<div class="col-md-12" :class="{'has-error': submitErrors.has('bill_company')}">
													<input
														id="bill_company"
														name="bill_company"
														key="input-bill-company"
														type="text"
														class="form-control input-sm"
														v-model.trim="bill_company">
												</div>
											</div>
										</div>

										<div v-if="availableBillLegalForms.length > 0" class="form-group" :class="{'has-error': submitErrors.has('bill_country_legal_form_id')}">
											<label for="bill_country_legal_form_id" class="control-label">{{ $t('forms.legal_form') }}*</label>
											<select
												id="bill_country_legal_form_id"
												v-model="bill_country_legal_form_id"
												class="form-control">
											<option v-for="legalForm in availableBillLegalForms"
												:value="legalForm.id"
												:key="legalForm.id">
													{{ legalForm.name_local }}
												</option>
											</select>
										</div>

										<div class="form-group bill">
											<div class="row">
												<label for="bill_name" class="col-md-12 control-label">{{ $t('forms.bill_name') }}*</label>
												<div class="col-md-12" :class="{'has-error': submitErrors.has('bill_name')}">
													<input
														id="bill_name"
														name="bill_name"
														key="input-bill-name"
														type="text"
														class="form-control input-sm"
														:placeholder="$t('forms.placeholders.bill_name')"
														v-model.trim="bill_name">
												</div>
											</div>
											<!--<p class="text-danger" v-if="errors.has('bill_name')">{{ errors.first('bill_name') }}</p>-->
										</div>
										<div class="form-group bill">
											<div class="row">
												<label for="bill_street_name" class="col-md-12 control-label">{{ $t('forms.street_name')
													}}*</label>
												<div class="col-md-9" :class="{'has-error': submitErrors.has('bill_street_name')}">
													<input
														id="bill_street_name"
														name="bill_street_name"
														key="input-bill-street-name"
														type="text"
														class="form-control input-sm"
														:placeholder="$t('forms.placeholders.street_name')"
														v-model.trim="bill_street_name">
												</div>
												<div class="col-md-3" :class="{'has-error': registrationErrors.has('bill_street_number') || submitErrors.has('bill_street_number')}">
													<input
														id="bill_street_number"
														name="bill_street_number"
														key="input-bill-street-number"
														type="bill_street_number"
														class="form-control input-sm"
														:placeholder="$t('forms.placeholders.street_number')"
														v-model.trim="bill_street_number">
												</div>
											</div>
										</div>
										<div class="form-group bill">
											<div class="row">
												<label for="bill_zip" class="col-md-12 control-label">{{ $t('forms.bill_zip_place') }}*</label>
												<div class="col-md-3" :class="{'has-error': submitErrors.has('bill_zip')}">
													<input
														id="bill_zip"
														name="bill_zip"
														key="input-bill-zip"
														type="bill_zip"
														class="form-control input-sm"
														:placeholder="$t('forms.placeholders.zip')"
														v-model.trim="bill_zip">
												</div>
												<div class="col-md-9" :class="{'has-error': registrationErrors.has('bill_place') || submitErrors.has('bill_place')}">
													<input
														id="bill_place"
														name="bill_place"
														key="input-bill-place"
														type="text"
														class="form-control input-sm"
														:placeholder="$t('forms.placeholders.place')"
														v-model.trim="bill_place">
												</div>
											</div>
										</div>

										<div v-show="requestAsType >= 1"
											class="form-group bill row"
											:class="{'has-error': submitErrors.has('bill_vat_id')}">
											<label for="bill_vat_id_prefix" class="col-md-12 control-label">{{ $t('forms.vat_id') }} <span v-show="billVatRequired">*</span>:</label>
											<div class="col-md-2">
												<select
													id="bill_vat_id_prefix"
													v-model="bill_vat_id_prefix"
													class="form-control">
													<option v-for="country in countryCodeOptions" v-bind:value="country.country_code" :key="country.id">
														{{ country.country_code }}
													</option>
												</select>
											</div>
											<div class="col-md-10">
												<input
													type="text"
													class="form-control"
													id="bill_vat_id"
													key="input-bill-vat-id"
													name="bill_vat_id"
													:placeholder='$t("forms.placeholders.vat_id")'
													v-model.trim="bill_vat_id"
													@keyup="checkBillVatId">
											</div>
										</div>
										<p class="text-danger" v-if="billVatRequired && bill_vat_id && !hasCorrectBillVatId">
											{{ $t('errors.vat_id') }}
										</p>
										<div class="form-group bill" :class="{'has-error': submitErrors.has('bill_email') }">
											<label class="control-label" for="bill_email">{{ $t('forms.email') }}*:</label>
											<input
												id="bill_email"
												name="bill_email"
												key="input-bill-email"
												class="form-control input-sm"
												type="email"
												:placeholder='$t("forms.placeholders.email")'
												v-model.trim="bill_email">
										</div>
										<div class="form-group bill" :class="{'has-error': submitErrors.has('bill_phone')}">
											<label for="bill_phone" class="control-label">{{ $t('forms.phone') }}</label>
											<input
												id="bill_phone"
												name="bill_phone"
												key="input-bill-phone"
												type="text"
												class="form-control input-sm"
												v-model.trim="bill_phone"
												:placeholder="$t('forms.placeholders.phone')">
										</div>
									</div>

									<div class="form-group">
										<div class="row">
											<div class="col-md-12" :class="{'has-error': submitErrors.has('confirmed_business_customer')}">
												<label class="form-checkbox">
													{{ $t('labels.confirmed_business_customer') }}*
													<input
														type="checkbox"
														name="confirmed_business_customer"
														key="input-confirmed-business-customer"
														v-model="confirmed_business_customer">
													<span class="form-checkmark"></span>
												</label>
											</div>
										</div>
									</div>

									<div class="form-group">
										<label v-html="generalTermsLink"></label>
									</div>

									<div class="form-group">
										<hr>
										<div class="text-center">
											<button type="button" class="btn btn-primary" @click="submitRequest"
												:disabled="!showSubmitButton">{{ $t("labels.submit_request") }}</button>
										</div>
									</div>
								</div>
								<div class="col-md-12 col-xs-12 register-blocks" v-else>
									<configurator-login-form :form="loginForm" @submit="loginUser"></configurator-login-form>
									<hr>
									<div class="row">
										<div class="col-md-12 col-xs-12">
											<h2>{{ $t('labels.no_account') }}</h2>
										</div>
									</div>
									<div class="col-md-12 col-sm-12 col-xs-12 text-center">
										<button type='button' class='btn btn-warning' @click="selectRequestAsRegistration">{{
											$t('labels.register') }}</button>
									</div>
								</div>
								<div>
									<span class="btn" @click="resetRequestAsType()" v-if="requestAsType > 1"><i
											class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}</span>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<configurator-checklist
								:exhibition="exhibition"
								:is-restricted-access="isRestrictedAccess"
								:is-size-set="isSizeSet"
								:is-booth-type-set="isBoothTypeSet"
								:is-required-info-set="isRequiredInfoSet"
								:vat-required="(vatRequired && vat_id.trim().length > 0)"
								:has-correct-vat-id="hasCorrectVatId"
								:is-address-set="isAddressSet"
								:is-registration="requestAsType === 3"
								:passwords-match="passwordsMatch"
								:is-hall-name-required="isHallNameRequired"
								:is-booth-number-required="isBoothNumberRequired"
								:is-additional-info-set="isAdditionalInfoSet"
								:has-bill-address="hasBillAddress"
								:is-payment-address-set="isPaymentAddressSet"
								:is-booth-label-set="isBoothLabelSet"
								:is-order-number-required="use_order_number"
								:is-order-number-set="isOrderNumberSet">
							</configurator-checklist>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<hr>
				<div class="wizard-footer">
					<div class="pull-left">
						<input type='button' class='btn btn-previous btn-warning' name='previous'
							:value='($t("buttons.prev_to") + " " + $t("tab.summary"))' @click="store.updateCurrentTab('summary')" />
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>

		<configurator-modal
			:is-active="showModal"
			:booth-types="boothTypes"
			:title="(!inEnglish) ? exhibition.name : exhibition.name_en"
			:user="user"
			@close="closeModal"
			@orderBooth="orderBooth"
			@orderArticles="orderArticles">
		</configurator-modal>
	</div>
</template>

<script setup>
import _ from 'lodash'
import { useMainStore } from '@/store'
import { computed, ref, watch, nextTick, onMounted, reactive, inject } from 'vue'
import Errors from '@/classes/Errors'
import { useI18n } from 'vue-i18n'
import Form from '@/classes/Form'
import { showErrorToast } from '@/utils/toast'
import Swal from 'sweetalert2'
import Logger from '@/services/logging'
import { filterAvailableRefinements } from '@/utils/boothRefinements'
import { calculateArticleCost, calculatePrintArticleCost } from '@/utils/basket.js'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
/** @type {Logger} */
const logger = inject('logger', null)
// define props
const props = defineProps({
	basket: {
		type: Object,
		required: true,
	},
	exhibition: {
		type: Object,
		required: true
	},
	user: {
		required: true
	},
	isRestrictedAccess: {
		type: Boolean,
		default: false
	},
	isEmbedded: {
		required: true
	},
	closed: {
		type: Boolean,
		default: false,
	},
	isExhibitionClosed: {
		type: Boolean,
		default: false
	},
	boothTypes: {
		type: Array,
		default: []
	},
	netValuesOnly: {
		type: Boolean,
		default: false,
	}
})
// define emits
const emit = defineEmits(['restrictTab', 'requestSubmitted', 'countryChanged', 'newUser'])
// define reactive props
const timer = ref(false)
const email = ref('')
const name = ref('')
const streetName = ref('')
const streetNumber = ref('')
const place = ref('')
const zip = ref('')
const phone = ref('')
const password = ref('')
const passwordConfirmation = ref('')
const company = ref('')
const country_id = ref(276)
const vat_id = ref('')
const comment = ref('')
const exhibitionHall = ref(props.basket.exhibitionHall ?? '')
const exhibitionBoothNumber = ref(props.basket.exhibitionBoothNumber ?? '')
const msgSuccess = ref(null)
const hasCorrectVatId = ref(false)
const vatCheckInProgress = ref(false)
const hasCorrectBillVatId = ref(false)
const requestInProgress = ref(false)
const requestSubmitted = ref(false)
const hasBillAddress = ref(false)
const bill_street_name = ref('')
const bill_street_number = ref('')
const bill_name = ref('')
const bill_zip = ref('')
const bill_place = ref('')
const bill_country_id = ref(276)
const bill_vat_id = ref('')
const bill_company = ref('')
const bill_email = ref('')
const bill_phone = ref('')
const country_legal_form_id = ref(null)
const bill_country_legal_form_id = ref(null)
const requestAsType = ref(0) // 0 = none selected, 1 = user, 2 = guest, 3 = registration
const vatRequired = ref(false)
const billVatRequired = ref(false)
const vat_id_prefix = ref('')
const bill_vat_id_prefix = ref('')
const selectedCountry = ref([])
const confirmed_business_customer = ref(false)
const order_number = ref('')
const use_order_number = ref(null)
const showModal = ref(false)
const errors = ref(new Errors())
const loginForm = reactive(new Form({
	email: null,
	password: null,
	exhibition_id: null
}))
const registrationForm = reactive(new Form({
	email: null,
	password: null,
	password_confirmation: null,
	company: null,
	country_id: null,
	country_legal_form_id: null,
	vat_id: null,
	name: null,
	street_name: null,
	street_number: null,
	place: null,
	zip: null,
	phone: null,
}))
const submitForm = reactive(new Form({
	basket: null,
	email: null,
	name: null,
	comment: null,
	company: null,
	country_legal_form_id: null,
	vat_id: null,
	country_id: null,
	street_name: null,
	street_number: null,
	place: null,
	zip: null,
	phone: null,
	exhibitionHall: null,
	exhibitionBoothNumber: null,
	password: null,
	password_confirmation: null,
	has_bill_address: false,
	bill_name: null,
	bill_place: null,
	bill_zip: null,
	bill_street_name: null,
	bill_street_number: null,
	bill_country_id: null,
	bill_vat_id: null,
	bill_company: null,
	bill_email: null,
	bill_phone: null,
	bill_country_legal_form_id: null,
	locale: null,
	confirmed_business_customer: null,
	user_id: null,
	order_number: null,
	use_order_number: false,
}))
// define computed props
const locale = computed(() => store.settings.locale)
const shoppingCart = computed(() => store.settings.shopping_cart)
const disabledBoothRefinementArticleIds = computed(() => store.availability.disabled_booth_refinement_ids)
const bookableArticleIds = computed(() => store.availability.bookable_article_ids)
const activePriceLevel = computed(() => store.activePriceLevel)
const countries = computed(() => store.tmp.countries)
const inEnglish = computed(() => store.inEnglish)
const checklist = computed(() => store.checklist)

const isBoothTypeSet = computed(() => {
	return props.isRestrictedAccess || (props.basket.boothType != null)
})

const showSubmitButton = computed(() => {
	if (props.isExhibitionClosed) {
		return false
	}

	// Check is commented out to find an error where the submit is still disabled despite
	// a complete checklist (every item is green)
	// return (
	// 	isSizeSet.value
	// 	&& isBoothTypeSet.value
	// 	&& isAddressSet.value
	// 	&& isAdditionalInfoSet.value
	// 	&& isRequiredInfoSet.value
	// 	&& requestAsType.value > 0
	// 	&& passwordsMatch.value
	// 	&& hasCorrectVatId.value
	// 	&& (hasBillAddress.value ? isPaymentAddressSet.value : true)
	// 	&& (hasBillAddress.value ? hasCorrectBillVatId.value : true)
	// 	&& confirmed_business_customer.value
	// 	&& isBoothLabelSet.value
	// 	&& isOrderNumberSet.value
	// )

	return checklist.value.minimum_checkout && confirmed_business_customer.value && isBoothLabelSet.value
})

const isSizeSet = computed(() => {
	return props.isRestrictedAccess || (props.basket.width > 0 && props.basket.depth > 0)
})

const isRequiredInfoSet = computed(() => {
	return (
		// !this.errors.has('email')
		// && !this.errors.has('name')
		// && !this.errors.has('company')
		email.value.trim() !== ""
		&& name.value.trim() !== ""
		&& company.value.trim() !== ""
	)
})

const isAdditionalInfoSet = computed(() => {
	if (
		props.exhibition.hall_settings.hall_name_required
		&& props.exhibition.hall_settings.booth_name_required
		&& exhibitionHall.value.trim() !== ""
		&& exhibitionBoothNumber.value.trim() !== ""
	) {
		return true
	} else if (
		!props.exhibition.hall_settings.hall_name_required
		&& !props.exhibition.hall_settings.booth_name_required
	) {
		return true
	} else if (
		props.exhibition.hall_settings.hall_name_required
		&& exhibitionHall.value.trim() !== ""
		&& !props.exhibition.hall_settings.booth_name_required
	) {
		return true
	} else if (
		props.exhibition.hall_settings.booth_name_required
		&& exhibitionBoothNumber.value.trim() !== ""
		&& !props.exhibition.hall_settings.hall_name_required
	) {
		return true
	}

	return false
})

const isHallNameRequired = computed(() => {
	return props.exhibition.hall_settings.hall_name_required
})

const isBoothNumberRequired = computed(() => {
	return props.exhibition.hall_settings.booth_name_required
})

const isPaymentAddressSet = computed(() => {
	return (
		// !this.errors.has('bill_street_name')
		// && !this.errors.has('bill_name')
		// && !this.errors.has('bill_zip')
		// && !this.errors.has('bill_place')
		// && !this.errors.has('bill_country_id')
		// && !this.errors.has('bill_company')
		// && !this.errors.has('bill_email')
		bill_street_name.value.trim() !== ""
		&& bill_name.value.trim() !== ""
		&& bill_zip.value.trim() !== ""
		&& bill_place.value.trim() !== ""
		&& bill_country_id.value !== null 
		&& bill_company.value.trim() !== ""
		&& bill_email.value.trim() !== ""
	)
})

const isAddressSet = computed(() => {
	return (
		// !this.errors.has('streetName')
		// && !this.errors.has('place')
		// && !this.errors.has('zip')
		// && !this.errors.has('country_id')
		streetName.value !== null
		&& place.value !== null
		&& zip.value !== null
		&& streetName.value.trim() !== ""
		&& place.value.trim() !== ""
		&& zip.value.trim() !== ""
		&& country_id.value != null
	)
})

const passwordsMatch = computed(() => {
	if (
		password.value !== null
		&& password.value !== ""
		&& passwordConfirmation.value !== null
		&& passwordConfirmation.value !== ""
	) {
		return (password.value == passwordConfirmation.value && password.value.length > 7)
	}

	return (requestAsType !== 3)
})

const generalTermsLink = computed(() => {
	const file = (inEnglish.value)
		? '/terms/LUECO-General-Conditions-of-Delivery-and-Payment.pdf'
		: '/terms/LUECO-Allgemeine-Geschaeftsbedingungen.pdf'

	return (t('labels.general_terms_submit').replace('[path_to_general_terms]' , file))
})

const isBoothLabelSet = computed(() => {
	if (shoppingCart.value.booth === null) {
		return true
	}

	const target = props.basket.selectedBooth ? props.basket.selectedBooth.refinements.reduce((t, refinement) => {
    	if (refinement.mandatory && refinement.booth_type === props.basket.boothType.type) {
      		t++
    	}

    	return t
  	}, 0) : 1;

	console.debug('mandatory target count', target)

	if (shoppingCart.value.booth_configuration.length === 0 && target === 0) {
		return true
	}

	const count = shoppingCart.value.booth_configuration.reduce((a, configuration) => {
		if (configuration.booth_refinement.mandatory) {
			a++
		}

		return a
	}, 0)

  	return count === target || availableRefinements.value.length === 0
})

const hallOptions = computed(() => {
	if (props.exhibition.hall_settings.hall_name_selection_active) {
		return [{
				label: (inEnglish.value) ? 'Please select' : 'Bitte auswählen',
				value: ''
			}]
			.concat(props.exhibition.hall_settings.hall_options.split(';')
				.filter(item => {
					return item.trim().length > 0
				})
				.map(item => {
					return {
						label: item,
						value: item
					}
				})
			)
	}

	return []
})

const isOrderNumberSet = computed(() => {
	if (!use_order_number.value && use_order_number.value !== null) {
		return true
	}

	return (order_number.value !== null && order_number.value.trim().length > 0)
})
const submitErrors = computed(() => {
	return submitForm.errors
})
const registrationErrors = computed(() => {
	return registrationForm.errors
})

const availableLegalForms = computed(() => {
	if (country_id.value === null || countries.value === null) {
		return []
	}

	const clonedCountries = _.cloneDeep(countries.value)
	const country = clonedCountries.find((country) => country.id === country_id.value)
	if (country === undefined || country.legal_forms === null || country.legal_forms.length === 0) {
		return []
	}

	return country.legal_forms
		.sort((a, b) => {
			return b.name_local.localeCompare(a.name_local)
		})
		.reverse()
})

const availableBillLegalForms = computed(() => {
	if (bill_country_id.value === null || countries.value === null) {
		return []
	}

	const clonedCountries = _.cloneDeep(countries.value)
	const country = clonedCountries.find((country) => country.id === bill_country_id.value)
	if (country === undefined || country.legal_forms === null || country.legal_forms.length === 0) {
		return []
	}

	return country.legal_forms
		.sort((a, b) => {
			return b.name_local.localeCompare(a.name_local)
		})
		.reverse()
})

const countryCodeOptions = computed(() => {
	if (countries.value === null) {
		return []
	}
	
	const clonedCountries = _.cloneDeep(countries.value)
	return clonedCountries.filter((country) => country.country_code !== null && country.country_code.trim() !== '')
		.sort((a, b) => {
			return b.country_code.localeCompare(a.country_code)
		})
		.reverse()
})

const countryOptions = computed(() => {
	if (countries.value === null || countries.value.length === 0) {
		return []
	}

	const clonedCountries = _.cloneDeep(countries.value)
	return clonedCountries
		.sort((a, b) => {
			return (inEnglish.value)
        ? b.name_english.localeCompare(a.name_english)
        : b.name.localeCompare(a.name)
		})
		.reverse()
})

const availableRefinements = computed(() => {
	return filterAvailableRefinements(
		shoppingCart.value,
		disabledBoothRefinementArticleIds.value,
		false,
		bookableArticleIds.value
	)
})
// define watchers
watch(() => exhibitionHall.value, () => {
	setExhibitionHall()
})
watch(() => exhibitionBoothNumber.value, () => {
	setExhibitionBoothNumber()
})
watch(() => props.user, async (newUser) => {
	if (newUser !== null) {
		name.value = newUser.name
		email.value = newUser.email
		company.value = (newUser.company === null) ? '' : newUser.company
		country_id.value = newUser.country_id
		if (newUser.vat_id !== null) {
			vat_id_prefix.value = newUser.vat_id.slice(0,1).toUpperCase()
			vat_id.value = newUser.vat_id.slice(2)
		} else {
			vat_id.value = ''
		}
		streetName.value = newUser.street_name
		streetNumber.value = newUser.street_number
		place.value = newUser.place
		zip.value = newUser.zip
		phone.value = newUser.phone
		requestAsType.value = 1
	}

	countryChanged(country_id.value)
	await checkBillVatId()
})
watch(() => country_id.value, () => {
	country_legal_form_id.value = null
})
watch(() => bill_country_id.value, () => {
	bill_country_legal_form_id.value = null
})
// define methods
const countryChanged = (country_id) => {
	if (
		countries.value === undefined
		|| countries.value === null
		|| countries.value.length === 0
	) {
		vatRequired.value = false

		return
	}

	let index = countries.value.findIndex((item) => item.id === country_id)

	if (index > -1) {
		//vatRequired.value = (countries.value[index].has_vat) ? true : false
    //vat id check disabled because check API is too slow 21.03.2023
    vatRequired.value = false
		vat_id_prefix.value = countries.value[index].country_code
		if (!hasBillAddress.value) {
			emit('countryChanged', countries.value[index])
		}
		checkVatId()
	} else {
		vat_id_prefix.value = ''
	}
}

const billCountryChanged = (country_id) => {
	if (
		countries.value === undefined
		|| countries.value === null
		|| countries.value.length === 0
	) {
		billVatRequired.value = false

		return
	}

	let index = countries.value.findIndex((item) => item.id === country_id)

	if (index > -1) {
		//billVatRequired.value = (countries.value[index].has_vat) ? true : false
    billVatRequired.value = false
    //vat id check disabled because check API is too slow 21.03.2023
		bill_vat_id_prefix.value = countries.value[index].country_code
		emit('countryChanged', countries.value[index])
		checkBillVatId()
	} else {
		bill_vat_id_prefix.value = ''
	}
}

const resetRequestAsType = () => {
	requestAsType.value = 0
}

const checkVatId = _.debounce(async () => {
	if (!vatRequired.value) {
		hasCorrectVatId.value = true
	} else {
    vatCheckInProgress.value = true;
		await validateVatId(vat_id_prefix.value + vat_id.value)
			.then(async (response) => {
				await nextTick()
				
				hasCorrectVatId.value = response
        vatCheckInProgress.value = false
			})
			.catch((err) => {
        vatCheckInProgress.value = false
				hasCorrectVatId.value = false
			})
	}
}, 750)

const checkBillVatId = _.debounce(async () => {
	if (!billVatRequired.value) {
		hasCorrectBillVatId.value = true
	} else {
		await validateVatId(bill_vat_id_prefix.value + bill_vat_id.value)
			.then(response => {
				hasCorrectBillVatId.value = response
			})
			.catch(() => {
				hasCorrectBillVatId.value = false
			})
	}
}, 750)

const validateVatId = (vatId) => {
	return new Promise((resolve, reject) => {
		axios.post('/configurator/checkVat', {
			vat_id: vatId
		})
			.then(response => {
				resolve(response.data.valid === 1)
			})
			.catch(err => {
				reject(false)
			})
	})
}

const isRequestValid = () => {

	return checklist.value.minimum_checkout
}

const submitRequest = () => {
	if (isRequestValid()) {
		requestInProgress.value = true
		if (requestAsType.value === 3) {
			registerUser()
		} else {
			sendOrderRequest()
		}
	}
}

const toggleHasBillAddress = () => {
	hasBillAddress.value = !hasBillAddress.value
}

const loginUser = async () => {
	loginForm.exhibition_id = props.exhibition.id
	await loginForm.post('/configurator/login')
		.then(response => {
			if (response.data.auth) {
				email.value = response.data.user.email
				name.value = response.data.user.name ?? ''
				company.value = response.data.user.company ?? ''
				country_id.value = response.data.user.country_id
				vat_id.value = response.data.user.vat_id
				streetName.value = response.data.user.street_name
				streetNumber.value = response.data.user.street_number
				place.value = response.data.user.place
				zip.value = response.data.user.zip
				phone.value = response.data.user.phone
				requestAsType.value = 1
				emit("newUser", response.data.user)
				loginForm.resetToOriginal()
				countryChanged(country_id.value)

				if (
					response.data.user.requests !== undefined
					&& response.data.user.requests !== null
					&& response.data.user.requests.length > 0
				) {
					openModal()
				}
			} else {
				showErrorToast(t('errors.invalid_credentials') + '#12')
			}
		})
		.catch(err => {
			showErrorToast(t('errors.invalid_credentials') + '#11')
		})
}

const selectRequestAsGuest = () => {
	requestAsType.value = 2
}

const selectRequestAsRegistration = () => {
	requestAsType.value = 3
}

const registerUser = async () => {
	registrationForm.email = email.value
	registrationForm.password = password.value
	registrationForm.password_confirmation = passwordConfirmation.value
	registrationForm.company = company.value
	registrationForm.country_id = country_id.value
	if (vat_id.value.trim().length > 0) {
		registrationForm.vat_id = vat_id_prefix.value + vat_id.value
	} else {
		registrationForm.vat_id = ''
	}
	registrationForm.name = name.value
	registrationForm.country_legal_form_id = country_legal_form_id.value
	registrationForm.street_name = streetName.value
	registrationForm.street_number = streetNumber.value
	registrationForm.place = place.value
	registrationForm.zip = zip.value
	registrationForm.phone = phone.value
	await registrationForm.post('/configurator/register')
		.then(response => {
			if (response.data.auth) {
				emit("newUser", response.data.user)
				requestAsType.value = 1
				// call submit request
				// timeout can be critical, but it should work
				setTimeout(() => {
					sendOrderRequest()
				}, 250)
				registrationForm.resetToOriginal()
			} else {
				showErrorToast(t('errors.registration_failed') + '#10')
				requestInProgress.value = false
			}
		})
		.catch(err => {
			if (err.response || err.data) {
				const response = (err.response) ? err.response : err
				const data = (err.response) ? err.response.data : err.data
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				if (response.status === 422 || err.status === 422) {
					let msg = t('errors.data_invalid')
					for (let key in data.errors) {
						data.errors[key].forEach((item) => {
							msg += ' ' + t(item)
						})
					}
					showErrorToast(msg + '#9', t('errors.registration_failed'), 10000)
				} else if (response.status === 419 || err.status === 419) {
					showErrorToast(t('errors.session_timeout') + '(#419)', t('errors.registration_failed'), 10000)
				} else {
					showErrorToast(t('errors.registration_failed') + '#8')
					logError(err.message, '#8', err.toString())
				}
			} else {
				showErrorToast(t('errors.registration_failed') + '#7')
				logError(err.message, '#7', err.toString())
			}
			requestInProgress.value = false
		})
}

const sendOrderRequest = async () => {
	// fetch exhibition information is a hot fix until 
	// the price calculation is also done by the backend to avoid manipulation
	await store.fetchExhibitionInformation()
	setSubmitFormForSubmit()
	await submitForm.post('/api/' + props.exhibition.slug + '/submit')
		.then(response => {
			if (response.data.errorCode === 0) {
				msgSuccess.value = t('success.message')
				requestSubmitted.value = true
				emit('requestSubmitted')
				resetRequestSubmitted()
				submitForm.resetToOriginal()
				Swal.fire({
					title: t('success.title'),
					text: t('success.message'),
					showCancelButton: false,
					confirmButtonText: 'Ok',
				})
				setTimeout(() => {
					store.updateCurrentTab('key_data')
				}, 1000);
			} else {
				if (response.data.errorCode === 902) {
					showErrorToast(t('errors.closed') + '#6')
				} else {
					showErrorToast(t('errors.please_try_again') + '#5')
					logger.error(err.message, '#5', err.toString())
				}
			}
			requestInProgress.value = false
		})
		.catch(err => {
			console.error(err)
			if (err.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				if (err.response.data !== null && err.response.data.errors) {
					let msg = t('errors.data_invalid')
					for (let key in err.response.data.errors) {
						err.response.data.errors[key].forEach((item) => {
							msg += ' ' + t(item)
						})
					}
					showErrorToast(msg + '#4')
				} else {
					showErrorToast(t('errors.please_try_again') + '#3')
					logger.error(err.message, '#3', err.toString())
				}
			} else if (err.request) {
				// The request was made but no response was received
				// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				// http.ClientRequest in node.js
				showErrorToast(t('errors.please_try_again') + '#2')
				if (err.status !== 422) {
					logger.debug(err.message, '#2', err.toString())
				} else {
					const data = submitForm.data()
					logger.debug(err.message, '#2', err.request.response.toString(), JSON.stringify(data), Object.values(submitForm.errors.errors).toString())
				}
			} else {
				// Something happened in setting up the request that triggered an Error
					showErrorToast(t('errors.please_try_again') + '#1')
					logger.error(err.message, '#1', err.toString())
			}
			requestInProgress.value = false
		})
	window.scrollTo(0,0)
}

const setSubmitFormForSubmit = () => {
	let basket = _.cloneDeep(props.basket)
	basket.print_items = _.cloneDeep(shoppingCart.value.print_items)
	basket.print_configuration = _.cloneDeep(shoppingCart.value.print_configuration)
	basket.booth_configuration = _.cloneDeep(shoppingCart.value.booth_configuration)
	basket.booth_draft = _.cloneDeep(shoppingCart.value.booth_draft)
	basket.group = shoppingCart.value.group
	submitForm.basket = basket
	// Temporary basket fix, values should be calculated in the backend
	if (submitForm.basket.selectedArticles.length === 0) {
		submitForm.basket.selectedArticles = _.cloneDeep(shoppingCart.value.items)
	}
	submitForm.basket.computed = store.costs
	submitForm.basket.computed.squareMeter = shoppingCart.value.getSquareMeter()
	submitForm.basket.computed.boothCost = shoppingCart.value.calculateCostsForBooth()
	submitForm.basket.computed.labelCost = 0
	submitForm.basket.computed.articleCost = calculateArticleCost(shoppingCart.value.items, shoppingCart.value.getSquareMeter(), props.netValuesOnly)
		+ calculatePrintArticleCost(
			shoppingCart.value.print_items,
			shoppingCart.value.getSquareMeter(),
			shoppingCart.value,
			props.netValuesOnly,
			props.exhibition.characters_inclusive
		)
	submitForm.basket.computed.priceLevelId = (activePriceLevel.value) ? activePriceLevel.value.id : null
	submitForm.email = email.value
	submitForm.name = name.value
	submitForm.comment = comment.value
	submitForm.company = company.value
	if (vat_id.value.trim().length > 0) {
		submitForm.vat_id = vat_id_prefix.value + vat_id.value
	} else {
		submitForm.vat_id = ''
	}
	submitForm.country_id = country_id.value
	submitForm.street_name = streetName.value
	submitForm.street_number = streetNumber.value
	submitForm.place = place.value
	submitForm.zip = zip.value
	submitForm.phone = phone.value
	submitForm.exhibitionHall = props.isEmbedded ? props.isEmbedded.exhibitionHall : exhibitionHall.value
	submitForm.exhibitionBoothNumber = props.isEmbedded
		? props.isEmbedded.exhibitionBoothNumber
		: exhibitionBoothNumber.value
	submitForm.password = password.value
	submitForm.password_confirmation = passwordConfirmation.value
	submitForm.has_bill_address = hasBillAddress.value
	submitForm.bill_name = bill_name.value
	submitForm.bill_place = bill_place.value
	submitForm.bill_zip = bill_zip.value
	submitForm.bill_street_name = bill_street_name.value
	submitForm.bill_street_number = bill_street_number.value
	submitForm.bill_country_id = bill_country_id.value
	if (bill_vat_id.value.trim().length > 0) {
		submitForm.bill_vat_id = bill_vat_id_prefix.value + bill_vat_id.value
	} else {
		submitForm.bill_vat_id = ''
	}
	submitForm.bill_company = bill_company.value
	submitForm.bill_email = bill_email.value
	submitForm.bill_phone = bill_phone.value
	submitForm.locale = locale.value
	submitForm.confirmed_business_customer = confirmed_business_customer.value
	submitForm.user_id = (props.user !== null) ? props.user.id : null
	submitForm.order_number = order_number.value
	submitForm.use_order_number = use_order_number.value
	submitForm.country_legal_form_id = country_legal_form_id.value
	submitForm.bill_country_legal_form_id = bill_country_legal_form_id.value
}

const resetRequestSubmitted = _.debounce(() => {
		exhibitionHall.value = props.isEmbedded ? props.isEmbedded.exhibitionHall : exhibitionHall.value
		exhibitionBoothNumber.value = props.isEmbedded
			? props.isEmbedded.exhibitionBoothNumber
			: exhibitionBoothNumber.value
		comment.value = ''
		requestSubmitted.value = false
	},
	5000
)

const setExhibitionHall = _.debounce(() => {
		props.basket.exhibitionHall = props.isEmbedded ? props.basket.exhibitionHall : exhibitionHall.value
	},
	500
)

const setExhibitionBoothNumber = _.debounce(() => {
		props.basket.exhibitionBoothNumber = props.isEmbedded
			? props.basket.exhibitionBoothNumber
			: exhibitionBoothNumber.value
	},
	500
)

const openModal = () => {
	showModal.value = true
}

const closeModal = () => {
	showModal.value = false
}

const orderBooth = (request) => {
	closeModal()
	shoppingCart.value.group = request.group + 1
}

const orderArticles = (request) => {
	// basket does not to be cleared, because the user did all the selections already
	shoppingCart.value.group = request.group
	const boothIndex = props.boothTypes.findIndex((type) => type.type === request.booth_type)
	if (boothIndex > -1) {
		props.basket.boothType = props.boothTypes[boothIndex]
	}
	props.basket.width = request.booth_width
	props.basket.depth = request.booth_depth
	props.basket.label = request.booth_label
	props.basket.exhibitionHall = request.exhibition_hall
	props.basket.exhibitionBoothNumber = request.exhibition_booth_number
	emit('restrictTab', 'articles_submit', 'step6')
	closeModal()
}

const logError = (message, info, dataString) => {
	logger.error(message, info, dataString)
}

onMounted(async () => {
	// created
	// pausing validator to prevent attach error
	if (props.user !== null) {
		name.value = props.user.name
		email.value = props.user.email
		company.value = (props.user.company === null) ? '' : props.user.company
		country_id.value = props.user.country_id
		if (props.user.vat_id !== null) {
			vat_id_prefix.value = props.user.vat_id.slice(0,1).toUpperCase()
			vat_id.value = props.user.vat_id.slice(2)
		} else {
			vat_id.value = ''
		}
		streetName.value = props.user.street_name
		streetNumber.value = props.user.street_number
		place.value = props.user.place
		zip.value = props.user.zip
		phone.value = props.user.phone
		requestAsType.value = 1
	}
	if (props.isEmbedded) {
		exhibitionHall.value = props.isEmbedded.exhibitionHall
		exhibitionBoothNumber.value = props.isEmbedded.exhibitionBoothNumber
	}

	countryChanged(country_id.value)
	await checkBillVatId()
	// mounted
	if (props.isEmbedded) {
		return
	}
	
	// pausing validator to prevent attach error
	if (
		exhibitionHall.value.trim().length === 0
		&& props.exhibition.hall_settings.hall_name_selection_active
		&& hallOptions.value.length > 0
	) {
		exhibitionHall.value = hallOptions.value[0].value
	}

	await store.fetchExhibitionInformation()
})
</script>
